// extracted by mini-css-extract-plugin
export default {"wraper":"DayPlan_wraper__FMtgM","title":"DayPlan_title__CeoDI","sub":"DayPlan_sub__Iso9N","items":"DayPlan_items__LhbV1"};